module.exports = __webpack_public_path__ + "assets/img/warrior-name-2202de84.png";